import { render, staticRenderFns } from "./EmarPatientDispenseReportV1Properties.vue?vue&type=template&id=55db48ed&"
import script from "./EmarPatientDispenseReportV1Properties.vue?vue&type=script&lang=js&"
export * from "./EmarPatientDispenseReportV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports